import React from 'react';
import { PlusIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { FAQS } from '../../data/content';
export function Faq() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-63" data-mp="x422oxiw9ku2">
      <div className="mx-auto max-w-3xl" data-id="element-64" data-mp="x5mvoipk8vpt">
        <Reveal className="text-center" data-id="element-65" data-mp="1223i98h4320s">
          <SectionBadge data-id="element-66" data-mp="122vemlij93s4">Preguntas frecuentes</SectionBadge>
          <h2 className="mt-5 font-display text-3xl leading-tight text-cocoa sm:text-5xl" data-id="element-67" data-mp="1prxtjlls8iix">
            Todo lo que <span className="italic text-terra" data-id="element-68" data-mp="1urk8q0l688ud">querés saber</span>
          </h2>
        </Reveal>

        <div className="mt-10 divide-y divide-sand-line border-y border-sand-line" data-id="element-69" data-mp="1g3653nfxkgcr">
          {FAQS.map(faq => <details key={faq.q} className="group" data-id="element-70" data-mp="1l0pjcncmot4p">
              <summary className="flex cursor-pointer list-none items-center gap-4 py-5 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-terra [&::-webkit-details-marker]:hidden" data-id="element-71" data-mp="1kz4p6yu87c7d">
                <span className="flex-1 text-base font-bold leading-snug text-cocoa" data-id="element-72" data-mp="2oq8ms7rjhl4b">{faq.q}</span>
                <PlusIcon className="h-4 w-4 flex-shrink-0 text-terra transition-transform duration-200 ease-out group-open:rotate-45" aria-hidden="true" data-id="element-73" data-mp="2jr5mf0mi832o" />
              </summary>
              <p className="pb-5 pr-8 text-sm leading-relaxed text-cocoa-soft sm:text-base" data-id="element-74" data-mp="2yi4rw2s1mbi1">{faq.a}</p>
            </details>)}
        </div>
      </div>
    </section>;
}